module.exports = __webpack_public_path__ + "media/icons/chevron-left-f76e3416.svg";